/**
 * Formats an email address to a proper name format
 * @param {string} email - The email address to format
 * @returns {string} - The formatted name
 * 
 * Examples:
 * - "marc.valeros@elementops.com" -> "Marc Valeros"
 * - "john.doe@company.com" -> "John Doe"
 * - "jane_smith@example.org" -> "Jane Smith"
 */
export const formatEmailToName = (email) => {
  if (!email || typeof email !== 'string') {
    return '';
  }

  // Extract the part before @
  const localPart = email.split('@')[0];
  
  if (!localPart) {
    return '';
  }

  // Replace common separators with spaces and split
  const nameParts = localPart
    .replace(/[._-]/g, ' ')  // Replace dots, underscores, and hyphens with spaces
    .split(' ')
    .filter(part => part.length > 0)  // Remove empty parts
    .map(part => {
      // Capitalize first letter of each part
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });

  return nameParts.join(' ');
};

export default formatEmailToName;
